module.exports = __webpack_public_path__ + "img/logo.dbdd32ff.png";